/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AuthData model module.
 * @module model/AuthData
 * @version 1.0
 */
class AuthData {
    /**
     * Constructs a new <code>AuthData</code>.
     * @alias module:model/AuthData
     */
    constructor() { 
        
        AuthData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AuthData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AuthData} obj Optional instance to populate.
     * @return {module:model/AuthData} The populated <code>AuthData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AuthData();

            if (data.hasOwnProperty('accessExpires')) {
                obj['accessExpires'] = ApiClient.convertToType(data['accessExpires'], 'Number');
            }
            if (data.hasOwnProperty('accessLiveTime')) {
                obj['accessLiveTime'] = ApiClient.convertToType(data['accessLiveTime'], 'Number');
            }
            if (data.hasOwnProperty('accessToken')) {
                obj['accessToken'] = ApiClient.convertToType(data['accessToken'], 'String');
            }
            if (data.hasOwnProperty('refreshToken')) {
                obj['refreshToken'] = ApiClient.convertToType(data['refreshToken'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('userName')) {
                obj['userName'] = ApiClient.convertToType(data['userName'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} accessExpires
 */
AuthData.prototype['accessExpires'] = undefined;

/**
 * @member {Number} accessLiveTime
 */
AuthData.prototype['accessLiveTime'] = undefined;

/**
 * @member {String} accessToken
 */
AuthData.prototype['accessToken'] = undefined;

/**
 * @member {String} refreshToken
 */
AuthData.prototype['refreshToken'] = undefined;

/**
 * @member {String} userId
 */
AuthData.prototype['userId'] = undefined;

/**
 * @member {String} userName
 */
AuthData.prototype['userName'] = undefined;






export default AuthData;

